import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=b5a1438a&scoped=true"
import script from "./finish.vue?vue&type=script&lang=js"
export * from "./finish.vue?vue&type=script&lang=js"
import style0 from "./finish.vue?vue&type=style&index=0&id=b5a1438a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a1438a",
  null
  
)

export default component.exports